import { snakify } from 'helpers/syntaxHelper';

/**
 * Middleware meant to be used as a PreProcessingBodyCallback into APIClient.
 * Deals specifically with widget post queries, by snakifying all field values
 * passed into body for dimensions, filters, and metrics subsection.
 */
export const widgetPreProcessingBodyCallback = (body: {
    chart: Record<string, any>;
}) => {
    if (typeof body.chart === 'undefined') {
        return body;
    }
    const chartKeysToTransform = ['filters', 'dimensions', 'metrics'];
    const formattedChart: any = {};
    Object.entries(body.chart).forEach(([chartKey, chartValue]) => {
        if (!chartKeysToTransform.includes(chartKey)) {
            formattedChart[chartKey] = chartValue;
            return;
        }
        formattedChart[chartKey] = chartValue.map((element: any) => ({
            ...element,
            field: snakify(element.field),
        }));
    });
    return { ...body, chart: formattedChart };
};
